export const LIST = 'prevenx/company/LIST'
export const SELECT = 'prevenx/company/SELECT'
